// extracted by mini-css-extract-plugin
export var active = "_ls-2";
export var recordingDot = "_ls-1";
export var recordingIndicator = "_ls-0";